import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=561cedc4"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=561cedc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports